import { useInfiniteQuery } from '@tanstack/react-query';
import { useAddOnLogError } from './helpers/useAddOnError';
export const createUseBosInfiniteQuery = ({ onLogError }) => (options) => {
    const infiniteQuery = useInfiniteQuery(options);
    return useAddOnLogError(infiniteQuery, onLogError);
};
